import React from 'react';

const Nomatch = () => {
    return (
        <div>
            <h3>404 Error: Page or Document not found</h3>
        </div>
    );
};

export default Nomatch;